/**
 * The design system's tools for the team — Debug's catalog, its sample notification and the choice of
 * service screen, and the `?lane=` override — show on the previews and on a laptop, never in production
 * (Adrián, 15-oct-2026: they are for trying things, and in a store the `ui-system-lane` flag decides).
 *
 * @rule   Off when EITHER says production: the build (Amplify builds `master`, `AWS_BRANCH`, for
 *         tracker.bronze.vision, app.bronze.vision and master.<app>.amplifyapp.com — vue.config.js) or the
 *         page's host. Either alone would be enough; both, because a production build served from a
 *         preview's host, or a preview's build reached from a production host, must not show them.
 * @rule   public/index.html repeats the host's test before the first paint, where no module has loaded.
 */
export const PRODUCTION_HOST = /(^|\.)bronze\.vision$|^master\./;

const BUILT_WITH_TOOLS = typeof __BRONZE_DEV_TOOLS__ === 'undefined' ? true : __BRONZE_DEV_TOOLS__;

export function devToolsEnabled(host = typeof location !== 'undefined' ? location.hostname : '') {
    return Boolean(BUILT_WITH_TOOLS) && !PRODUCTION_HOST.test(host || '');
}
